import creditCardType, { addCard, types, updateCard } from "credit-card-type";

/**
 * Set up packages for usage in our environment
 * - niceType is set to strings that checkout frontend uses for cards
 * - cards that the library doesn't support are added here
 */
updateCard(types.VISA, { niceType: "visa", gaps: [4, 8, 12, 16] });
updateCard(types.MASTERCARD, {
  niceType: "mastercard",
});
updateCard(types.MAESTRO, {
  niceType: "maestro",
  gaps: [4, 8, 12, 16],
});
updateCard(types.AMERICAN_EXPRESS, {
  niceType: "amex",
});
updateCard(types.DISCOVER, {
  niceType: "discover",
});
updateCard(types.JCB, { niceType: "jcb" });
updateCard(types.UNIONPAY, { niceType: "unionPay", gaps: [4, 8, 12, 16] });
updateCard(types.DINERS_CLUB, { niceType: "dinersClub" });

// NOTE: The following cards are not supported by the library, but are used in checkout frontend
// eslint-disable-next-line
!creditCardType.getTypeInfo("cartes-bancaires") &&
  addCard({
    type: "cartes-bancaires",
    niceType: "cartesBancaires",
    patterns: [4],
    gaps: [4, 8, 12],
    lengths: [16, 18, 19],
    code: {
      name: "CVV",
      size: 3,
    },
  });
